// Angular
import { Component, OnDestroy } from '@angular/core';

// Models
import { AppCleanup } from '../../../../../../shared/models';

@Component({
  selector: 'calibration-help-dialog',
  templateUrl: './calibration-help-dialog.component.html',
  styleUrl: './calibration-help-dialog.component.scss',
})
export class CalibrationHelpDialogComponent extends AppCleanup implements OnDestroy {
  componentTitle: string = 'Sensor calibration instructions';
  imageUrl: string = 'assets/images/calibration-help.png';

  constructor() {
    super();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }
}
